"use client"

import React, {useEffect, useRef} from "react";
import { z } from "zod";
import { useRouter } from 'next/navigation'
import {
  Form,
} from "@/components/ui/form"

const FiltersForm = ({className = '', children, form, formSchema, ...props}) => {

  const router = useRouter()

  const {
    watch,
    handleSubmit
  } = form;

  const radioTypeValue = watch('type');
  const createdStartValue = watch('createdStart');
  const createdEndValue = watch('createdEnd');

  const formRef = useRef(null);

  function onSubmit(values: z.infer<typeof formSchema>) {

    const filteredValues = Object.entries(values).filter(([key, value]) => value !== '').filter(([key, value]) => value !== 'all');
    const queryParams = Object.fromEntries(filteredValues);

    // @ts-ignore
    router.push({ pathname: '', query: queryParams })
  }

  useEffect(() => {
    if (formRef.current) {
      handleSubmit(onSubmit)()
    }
  }, [radioTypeValue, createdStartValue, createdEndValue, handleSubmit]);

  return (
    <div>

      <Form {...form}>
        <form ref={formRef} onSubmit={handleSubmit(onSubmit)} className={className}>
          {children}
        </form>
      </Form>

    </div>
  )

}

export default FiltersForm
